import { combineReducers, configureStore } from '@reduxjs/toolkit'
import authSlice from './slices/auth/authSlice'
import apiAccess from '../api/apiAccess'
import taxSlice from './slices/tax/taxSlice'
import applySlice from './slices/apply/applySlice'
import configSlice from './slices/config/configSlice'
import dashboardSlice from './slices/dashboard/dashboardSlice'
import paymentSlice from './slices/payment/paymentSlice'
import licenseViewSlice from './slices/licenseView/licenseViewSlice'
import globalsSlice from './slices/globals/globalsSlice'
import flowSlice from './slices/flow/flowSlice'
import updateSlice from './slices/update/updateSlice'
import renewSlice from './slices/renew/renewSlice'
import { persistStore, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import adminUpdateSlice from './slices/adminUpdate/adminUpdateSlice'

const persistConfig = {
    key: "root",
    storage
}

const rootReducer = {
    config: configSlice,
    auth: authSlice,
    tax: taxSlice,
    apply: applySlice,
    update: updateSlice,
    adminUpdate: adminUpdateSlice,
    renew: renewSlice,
    dashboard: dashboardSlice,
    payment: paymentSlice,
    licenseView: licenseViewSlice,
    flow: flowSlice,
    globals: globalsSlice
}

const persistedReducer = persistReducer(persistConfig, combineReducers(rootReducer));

const store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            thunk: {
                extraArgument: apiAccess,
            },
            serializableCheck: false,
        }),
    devTools: true,
})

export const persistor = persistStore(store);
export default store
